import {Globe, MailCheck, MapPin, Phone } from 'lucide-react'
import { Helmet } from 'react-helmet-async';
import ContactForm from "./partials/ContactForm"
export default function ContactUs() {

  return (
    <>


<div>
  
{/* SEO Meta Tags */}
    <Helmet>
  <title>Get in Touch | V Hotel Delhi Airport - Quick Support</title>

  <meta
    name="description"
    content="Need help with booking or directions? Reach out to our support team—we’re just a call or message away. V Hotel is here to assist, always."
  />
  <meta
    name="keywords"
    content="Contact, V Hotel, The Grand Shoba, Hotel contact, New Delhi hotel, booking inquiries, hotel phone, hotel email"
  />

  <meta property="og:title" content="Get in Touch | V Hotel Delhi Airport - Quick Support" />
  <meta
    property="og:description"
    content="Need help with booking or directions? Reach out to our support team—we’re just a call or message away. V Hotel is here to assist, always."
  />
  <meta
    property="og:image"
    content="https://www.vhotelthegrandshoba.com/images/contactus/contact-us-header-image.jpg"
  />
  <meta property="og:url" content="https://www.vhotelthegrandshoba.com/contact-us" />

  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Contact Us - V Hotel The Grand Shoba" />
  <meta
    name="twitter:description"
    content="Reach V Hotel The Grand Shoba in Mahipalpur, New Delhi—just minutes from IGI Airport. Contact us for bookings, events, or any inquiries."
  />
  <meta
    name="twitter:image"
    content="https://www.vhotelthegrandshoba.com/images/contactus/contact-us-header-image.jpg"
  />

  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://www.vhotelthegrandshoba.com/contact-us" />
</Helmet>








      
      <div className="contact-us ">
        <img src="/images/contactus/contact-us-header-image_.jpg" loading='lazy' title='V Hotel The Grnad Shoba Contact ' alt="V Hotel The Grnad Shoba contact " />
        {/* <span className='contact-us-text dine'>CONTACT US</span> */}
    </div>
    <div className="contact-container">
      <h1 className="contact-title">Contact Us</h1>

      <div className="info-boxes">
        <div className="info-card">
        <Phone />
          <h3>Call Us</h3>
           <a title='v hotel the grand shoba phone' href="tel:++919811320209 ">+91  9811320209 </a> <br />
           
           <a title='v hotel the grand shoba phone' href="tel:+919811226576" >+91 9811226576</a>
        </div>
        <div className="info-card">
        <MailCheck />
          <h3>Email Us</h3>
          <a title='v hotel the grand shoba email' href="mailto:info@vhotelindia.com">info@vhotelthegrandshoba.com</a> <br />
          {/* <a title='v hotel the grand shoba phone' href="mailto:info@vhotelindia.com">booking@vhotelthegrandshoba.com</a> */}
        </div>
        <div className="info-card">
        <MapPin />
          <h3>Address</h3>
            <a title='v hotel the grand shoba address' href="https://www.google.com/maps/place/V+Hotel+The+Grand+Shoba/@28.5519703,77.1333988,17z/data=!3m1!4b1!4m9!3m8!1s0x390d1d86b229e7bf:0x5a55a0c4e18ced29!5m2!4m1!1i2!8m2!3d28.5519703!4d77.1333988!16s%2Fg%2F11cr_xfxt4?entry=ttu&g_ep=EgoyMDI1MDQzMC4xIKXMDSoASAFQAw%3D%3D" target='_blank'>1031, Mahipalpur , Vasant kunj Bypass, Road, Mahipalpur Extension, New Delhi</a>
        </div>
        <div className="info-card">
        <Globe />
          <h3>Website</h3>
          <a title='v hotel the grand shoba website url' href="https://www.vhotelthegrandshoba.com" target='_blank'>www.vhotelthegrandshoba.com</a>
        </div>
      </div>
    </div>
    
                <div className="container query-main-container">
                    <div className="row">

                        <div className="col-md-6">
          <a title='v hotel the grand shoba phone' href="https://www.google.com/maps/place/V+Hotel+The+Grand+Shoba/@28.5519703,77.1333988,17z/data=!3m1!4b1!4m9!3m8!1s0x390d1d86b229e7bf:0x5a55a0c4e18ced29!5m2!4m1!1i2!8m2!3d28.5519703!4d77.1333988!16s%2Fg%2F11cr_xfxt4?entry=ttu&g_ep=EgoyMDI1MDQzMC4xIKXMDSoASAFQAw%3D%3D" target='_blank'>
    
                          <div className="map-section">
                            
        <iframe
          title="hotel-location"
          src="https://maps.google.com/maps?q=V+Hotel+The+Grand+Shoba%2C+1031%2C+Mahipalpur+%2C+Vasant+kunj+Bypass%2C+Road%2C+Mahipalpur+Extension%2C+New+Delhi%2C+delhi%2C+Delhi+110037&layer=c&output=embed"
          style={{ border: 0 }}
          alt="v hotel the grand shoba map"
          allowFullScreen=""

          loading="lazy"
          className='contactus-map'
        ></iframe>
                         </div>
                        </a>
                        </div>
    
                       <ContactForm/>
                    </div>
                </div>
</div>


    
    </>
  )
}
